import { Employee } from "domain/entities/employee";
import { TimesheetReport } from "domain/entities/timesheet-report";
import { TimesheetAnalysisData } from "./types";

export const buildTimesheetAnalysisData = (
  employee: TimesheetReport,
  employeeInfo: Employee | undefined,
  daysMonth: number
): TimesheetAnalysisData => {
  const workHoursPerDay =
    Number(employeeInfo?.workHoursPerDay) > 0
      ? Number(employeeInfo?.workHoursPerDay)
      : 8;

  const isSupportService =
    employeeInfo?.isSuportService ?? false;

  const daysAbscent = new Map<number, number>();
  const daysVacation = new Map<number, number>();
  const daysHoliday = new Map<number, number>();
  const daysAllocated = new Map<number, number>();
  const daysRest = new Map<number, number>();

  let sumAllocated = 0;
  let sumAbsent = 0;
  let sumVacation = 0;
  let sumPrevention = 0;
  let sumDisplacement = 0;
  let sumExtraHour = 0;
  let sumRestHours = 0;

  for (let day = 1; day <= daysMonth; day++) {
    const selectedDay = employee.days.find(
      (item) => item.day === day
    );

    const restHours =
      selectedDay?.activities.reduce((acc, item) => {
        if (
          item.type.toLowerCase() === "abscence" &&
          item.name.toLowerCase() ===
            "dia de descanso (colaboradores de suporte)"
        ) {
          return acc + item.hours;
        }

        return acc;
      }, 0) ?? 0;

    daysRest.set(day, restHours);
    sumRestHours += restHours;

    const vacationHours =
      selectedDay?.activities.reduce((acc, item) => {
        if (
          item.type.toLowerCase() === "abscence" &&
          (
            item.name.toLowerCase() === "férias" ||
            item.name.toLowerCase() === "compensação"
          )
        ) {
          return acc + item.hours;
        }

        return acc;
      }, 0) ?? 0;

    const normalizedVacationHours =
      vacationHours > 0 &&
      vacationHours !== workHoursPerDay
        ? workHoursPerDay
        : vacationHours;

    daysVacation.set(day, normalizedVacationHours);
    sumVacation += normalizedVacationHours;

    const absentHours =
      selectedDay?.activities.reduce((acc, item) => {
        if (
          item.type.toLowerCase() === "abscence" &&
          item.name.toLowerCase() !== "férias" &&
          item.name.toLowerCase() !== "feriado" &&
          item.name.toLowerCase() !== "compensação" &&
          item.name.toLowerCase() !==
            "dia de descanso (colaboradores de suporte)"
        ) {
          return acc + item.hours;
        }

        return acc;
      }, 0) ?? 0;

    daysAbscent.set(day, absentHours);
    sumAbsent += absentHours;

    const holidayHours =
      selectedDay?.activities.reduce((acc, item) => {
        if (
          item.type.toLowerCase() === "abscence" &&
          item.name.toLowerCase() === "feriado"
        ) {
          return acc + item.hours;
        }

        return acc;
      }, 0) ?? 0;

    daysHoliday.set(day, holidayHours);

    const allocatedHours =
      selectedDay?.activities.reduce((acc, item) => {
        if (item.type.toLowerCase() === "po") {
          return acc + item.hours;
        }

        return acc;
      }, 0) ?? 0;

    daysAllocated.set(day, allocatedHours);
    sumAllocated += allocatedHours;

    const hasPrevention =
      selectedDay?.activities.some((item) =>
        item.name.includes("Prevenção")
      ) ?? false;

    if (hasPrevention) {
      sumPrevention++;
    }

    const hasDisplacement =
      selectedDay?.activities.some((item) =>
        item.name.includes("Deslocação")
      ) ?? false;

    if (hasDisplacement) {
      sumDisplacement++;
    }

    const extraHours =
      selectedDay?.activities.find((item) =>
        item.name.includes("Hora Extra")
      )?.hours ?? 0;

    sumExtraHour += extraHours;
  }

  return {
    name: employee.name,

    daysAllocated,
    daysAbscent,
    daysVacation,
    daysHoliday,
    daysRest,

    sumAbsent,
    sumVacation,
    sumAllocated,

    preventionsCount: sumPrevention,
    displacementCount: sumDisplacement,

    workHoursPerDay,
    isSupportService,

    extraHourCount: sumExtraHour,
    sumRestHours,
  };
};